/* global document */
/**
 * The function returns the truncated summary from start and till the last full-stop.
 * @param {string} productBodyHtml HTML string to read
 * @returns The truncated summary, an empty string if failed
 */
const getProductDescription = (productBodyHtml) => {
    if (!productBodyHtml) 
        return '';
    const documentElement = document.createElement('html');
    documentElement.innerHTML = productBodyHtml;
    let truncatedString = documentElement.textContent.trim().slice(0, 150);
    const lastIndexOfFullStop = truncatedString.lastIndexOf('.');
    if (lastIndexOfFullStop === -1) 
        return truncatedString;
    return truncatedString.slice(0, lastIndexOfFullStop + 1);
};

export default getProductDescription;